import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=0635488a"
import script from "./SplashScreen.vue?vue&type=script&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&lang=ts"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=0635488a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports